<script lang="ts" setup>
    import { computed } from "vue";
    import { AlignmentTypeStyle, PaginationButtonSizeStyle } from "../../Enums/UiEnums";
    import PaginationButtons from '../Pagination/PaginationButtons.vue';

    const props = withDefaults(defineProps<{        
        itemsPerPage?: number,
		currentTopItem?: number,
		data: any[],
        alignStyle?: AlignmentTypeStyle,
        buttonSize?: PaginationButtonSizeStyle,
        numberMaxPagesToDisplay?: number
    }>(), {
        itemsPerPage: undefined,
        currentTopItem: 1,
        alignStyle: AlignmentTypeStyle.Right,
        buttonSize: PaginationButtonSizeStyle.Small,
        numberMaxPagesToDisplay: 3
    });  

    const emit = defineEmits<{
        "update:currentTopItem": [currentTopItem: number]
    }>();

    const numberOfPages = computed<number>(() => {
        return props.itemsPerPage ? Math.ceil((props.data.length) / props.itemsPerPage) : 0;
	});

    const usePagination = computed<boolean>(() => (props.itemsPerPage ?? 0) > 0);

    const visibleItems = computed<any[]>(() => {
        if (!usePagination.value) {
            return props.data;
        }
        return props.data.slice(props.currentTopItem, props.currentTopItem + (props.itemsPerPage ?? 0));
	});
    
    function setCurrentPage(page: number) {
        emit("update:currentTopItem", page * (props.itemsPerPage ?? 0));
    }

    const pagesToDisplay = computed<number>(() => {            
        return numberOfPages.value < props.numberMaxPagesToDisplay ? numberOfPages.value : props.numberMaxPagesToDisplay;
    });
     
</script>
  
<template>
    <slot name="header" v-if="usePagination && props.data.length > (props.itemsPerPage ?? 0)">
        <PaginationButtons 
            :totalItems="props.data.length" 
            :buttonSize="props.buttonSize" 
            :alignStyle="props.alignStyle" 
            :itemsPerPage="props.itemsPerPage" 
            :currentTopItem="props.currentTopItem" 
            @click="(_currentTopItem, currentPage) => setCurrentPage(currentPage)" />
    </slot>

    <slot name="body" :visibleItems="visibleItems"></slot>    

    <slot name="footer" :totalItems="props.data.length" v-if="usePagination && props.data.length > (props.itemsPerPage ?? 0)">
        <PaginationButtons 
            :totalItems="props.data.length" 
            :buttonSize="props.buttonSize" 
            :alignStyle="props.alignStyle" 
            :itemsPerPage="props.itemsPerPage" 
            :currentTopItem="props.currentTopItem" 
            @click="(_currentTopItem, currentPage) => setCurrentPage(currentPage)" />
    </slot>
    

</template>
  